export const validation = {
  name: 'required|min:5|max:50',
  title_es: 'min:3|max:255',
  description_es: 'min:3',
  cover: 'min:3',
  position: 'min_value:1|max:2',
  status_id: 'required|min_value:1|numeric|max_value:9',
  type_id: 'required|numeric|min_value:1|max:11'
}

export const GalleryFields = function () {
  return {
    name: null,
    title_es: null,
    description_es: null,
    cover: null,
    status_id: null,
    type_id: null,
    position: null
  }
}

export const statusList = [
  {
    id: 1,
    name: 'Activa'
  },
  {
    id: 2,
    name: 'Inactiva'
  }
]

export const texts = {
  galleryEdit: {
    title: 'Editar Galería Existente',
    subtitle: 'Edita la información de la galería, cambiar imagen, contenido, posición.',
    submit: 'Actualizar Galería',
    messages: {
      success: {
        title: 'GALERÍA ACTUALIZADA',
        text: 'Esta galería ha sido actualizada correctamente'
      }
    }
  },
  galleryNew: {
    title: 'Añadir Nueva Galería',
    subtitle: 'Crear nuevas galerías para el sitio web, crea galerías, agrupalas por tipo.',
    submit: 'Crear Galería',
    messages: {
      success: {
        title: 'GALERÍA CREADA',
        text: 'Se ha creado correctamente la nueva galería'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/galleries/mocks.js